// extracted by mini-css-extract-plugin
export default {"button":"buyPoints_button__5PuKo","points_img":"buyPoints_points_img__jlqoH","heading":"buyPoints_heading__F0yrh","container":"buyPoints_container__rsWat"};